import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CssBaseline } from "@mui/material";
import EnrollFrame from "../../elements/EnrollFrame";
import HeroSection from "../../elements/HeroSection";
import HelpYourChildSection from "./HelpYourChildSection";
import SparrowSection from "../approachPage/SparrowSection";
import LanguagesOfTomorrowSection from "./LanguagesOfTomorrowSection";
import { DiscoverPotentialSection } from "./DiscoverPotentialSection";
import { MoreForChildrenSection } from "./MoreForChildrenSection";

const ProgramPage: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <CssBaseline />
      <HeroSection
        mainTitle={<>{t("ProgramPage.mainTitle")}</>}
        secondaryTitle={
          <>
            {t("ProgramPage.secondaryTitle1")}
            <br />
            {t("ProgramPage.secondaryTitle2")}
          </>
        }
        buttonText={t("ProgramPage.buttonText")}
        buttonOnClickPath={"enroll"}
        backgroundImageUrl={"/programPage/hero.webp"}
        altImage={t("AltImages.alt_image_program")}
      />
      <HelpYourChildSection />
      <SparrowSection
        image="/birds/blue.webp"
        title1={t("ProgramPage.SparrowSection.title_1")}
        title2={t("ProgramPage.SparrowSection.title_2")}
        description2={t("ProgramPage.SparrowSection.description_2")}
        description3={t("ProgramPage.SparrowSection.description_3")}
        description4={t("ProgramPage.SparrowSection.description_4")}
        marginTop={true}
        marginBottom={true}
        border={true}
        changeColor={true}
      />
      <LanguagesOfTomorrowSection />
      <DiscoverPotentialSection
        title={t("ProgramPage.DiscoverPotentialSection.Section1.title")}
        description={t(
          "ProgramPage.DiscoverPotentialSection.Section1.description"
        )}
        image="/programPage/kinder11.webp"
        accordionItems={[
          {
            title: t(
              "ProgramPage.DiscoverPotentialSection.Section1.accordionItems.item1.title"
            ),
            content: t(
              "ProgramPage.DiscoverPotentialSection.Section1.accordionItems.item1.content"
            ),
          },
          {
            title: t(
              "ProgramPage.DiscoverPotentialSection.Section1.accordionItems.item2.title"
            ),
            content: t(
              "ProgramPage.DiscoverPotentialSection.Section1.accordionItems.item2.content"
            ),
          },
          {
            title: t(
              "ProgramPage.DiscoverPotentialSection.Section1.accordionItems.item3.title"
            ),
            content: t(
              "ProgramPage.DiscoverPotentialSection.Section1.accordionItems.item3.content"
            ),
          },
        ]}
      />
      <DiscoverPotentialSection
        title={t("ProgramPage.DiscoverPotentialSection.Section2.title")}
        description={t(
          "ProgramPage.DiscoverPotentialSection.Section2.description"
        )}
        image="/programPage/kinder11.webp"
        reverse={true}
        accordionItems={[
          {
            title: t(
              "ProgramPage.DiscoverPotentialSection.Section2.accordionItems.item1.title"
            ),
            content: t(
              "ProgramPage.DiscoverPotentialSection.Section2.accordionItems.item1.content"
            ),
          },
          {
            title: t(
              "ProgramPage.DiscoverPotentialSection.Section2.accordionItems.item2.title"
            ),
            content: t(
              "ProgramPage.DiscoverPotentialSection.Section2.accordionItems.item2.content"
            ),
          },
        ]}
      />
      <MoreForChildrenSection />
      <EnrollFrame />
    </>
  );
};

export default ProgramPage;
